const allActivedModals = []

export default allActivedModals
